import { SearchableSelect } from "@/components/searchable-select";
import { US_STATE_OPTIONS, normalizeUSState } from "@/lib/us-states";
import { cn } from "@/lib/utils";

interface StateSelectProps {
  value: string | null | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  /** Optional id for the trigger so an external <label htmlFor> resolves. */
  id?: string;
}

export function StateSelect({
  value,
  onChange,
  placeholder = "Select state…",
  className,
  disabled,
  id,
}: StateSelectProps) {
  const normalized = normalizeUSState(value);
  return (
    <SearchableSelect
      id={id}
      value={normalized}
      onChange={onChange}
      options={US_STATE_OPTIONS}
      placeholder={placeholder}
      className={cn(disabled && "opacity-50 pointer-events-none", className)}
    />
  );
}
